import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalOptionsEvent.scss';
import { Grid, cls } from '../../packages/components';
import EventOptions from '../EventOptions';
import UtilsSearch from '../../containers/Search/UtilsSearch';

const ModalOptionsEvent = ({ data = {}, streamType = null, streamContentType = null, handleClose = null, changeLangCb = null, keyFrom = null, history = null, getLinks = null, from = null, showFullEpg = null, onClose=()=>{}}) => {
    const modalProps = {
        childrenClassName: 'modal_full_height_options_event',
        callbackWhenBack: onClose
    };

    UtilsSearch.updateDataStoreFlowFuture({isFuture: false, itemClick: {}})

    return (
        <ModalWrapper {...modalProps}>
            <Grid className={cls(`aaf-main-modal-options-event`)}>
                <EventOptions
                    data={data}
                    streamType={streamType}
                    streamContentType={streamContentType}
                    handleClose = {handleClose}
                    changeLangCb ={changeLangCb}
                    keyFrom = {keyFrom}
                    history = {history}
                    getLinks = {getLinks}
                    from = {from}
                    showFullEpg = {showFullEpg}
                    onClose={onClose}
                />
            </Grid>
        </ModalWrapper>
    );
};

export default withOnClose(ModalOptionsEvent);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalOptionsEvent.jsx